import { ReactElement } from 'react';

import { MenuItemProps } from '@mui/material';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isMenuItemElement = (element: any): element is ReactElement<Partial<MenuItemProps>> => {
  return element?.props?.value !== undefined;
};
